import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                撸撸社
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              撸撸社官网 - 官方正版入口，提供高清资源、极速播放与全天候客服支持，您的专属娱乐平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/hot" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门推荐</Link></li>
              <li><Link to="/category/new" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">最新上架</Link></li>
              <li><Link to="/category/hd" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">高清专区</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">会员服务</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">会员权益</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </div>
                service@lulushe.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </div>
                400-XXX-XXXX
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line"></i>
                </div>
                7×24小时在线
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2024 撸撸社官网 版权所有 | 撸撸社官方网站
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-500 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-sm text-background-500 hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-sm text-background-500 hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}